function AirbnbIcon({ size = 24, className = '' }) {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      <path 
        d="M12.001 18.275c-.94-1.193-1.809-2.454-2.601-3.77-.717-1.173-1.322-2.413-1.803-3.701-.338-.924-.532-1.773-.532-2.5 0-1.243.474-2.4 1.333-3.26.86-.858 2.017-1.333 3.26-1.333 1.243 0 2.4.474 3.26 1.333.86.86 1.333 2.017 1.333 3.26 0 .727-.193 1.577-.532 2.5-.48 1.288-1.086 2.528-1.803 3.7-.792 1.317-1.661 2.578-2.601 3.771l-.157.203-.157-.203zm0-16.044c-2.844 0-5.132 2.288-5.132 5.132 0 3.06 2.288 6.478 5.132 10.29 2.844-3.812 5.132-7.23 5.132-10.29 0-2.844-2.288-5.132-5.132-5.132zm0 7.132c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z"
        fill="#FF5A5F"
      />
      <path 
        d="M12 2.23c-2.844 0-5.132 2.288-5.132 5.132 0 3.06 2.288 6.478 5.132 10.29 2.844-3.812 5.132-7.23 5.132-10.29 0-2.844-2.288-5.132-5.132-5.132zm0 2.312c1.243 0 2.4.474 3.26 1.333.86.86 1.333 2.017 1.333 3.26 0 .727-.193 1.577-.532 2.5-.48 1.288-1.086 2.528-1.803 3.7-.792 1.317-1.661 2.578-2.601 3.771l-.157.203-.157-.203c-.94-1.193-1.809-2.454-2.601-3.77-.717-1.173-1.322-2.413-1.803-3.701-.338-.924-.532-1.773-.532-2.5 0-1.243.474-2.4 1.333-3.26.86-.858 2.017-1.333 3.26-1.333z"
        fill="#FF5A5F"
      />
    </svg>
  );
}

export default AirbnbIcon;
